<template>
  <div>
    <player-search></player-search>
  </div>
</template>

<script>
  import configure from '../../configure'
  import PlayerSearch from '../../components/configuration/PlayerSearch.vue'
  import * as actions from '../../vuex/actions'
  import {
    getConfigChampionship,
    getConfigRegistrations
  } from '../../vuex/getters'

  export default {
    vuex: {
      getters: {
        championship: getConfigChampionship,
        registrations: getConfigRegistrations
      },
      actions: actions
    },
    components: {PlayerSearch},
    data() {
      return {
      }
    },
    ready() {
    },
    methods: {
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Players.vue?1737b862
 **/